<template>
	<div>
		<div class="app-container">
			
			<div>
				<!-- <button @click="resetData">Clear Data</button> -->
				<!-- <button @click="addData" :disabled="updatingData">Add Data</button> -->
			</div>

			<!--
			<span class="user-logged">Logged as</span>
			<select v-model="userID">
				<option v-for="user in users" :key="user.employeeID" :value="user.employeeID">
					{{ user.username }}
				</option>
			</select>
			-->

			<!--
			<div class="button-theme">
				<button @click="theme = 'light'" class="button-light">Light</button>
				<button @click="theme = 'dark'" class="button-dark">Dark</button>
			</div>
			-->

            <div v-if="shouldEnableConversations">
                <conversations-container-v2
                    v-if="showChat && userID"
                    :currentUserId="userID"
                    :theme="theme"                   
                />                
            </div>
			<div v-else><span>You do not have this feature enabled yet. Please contact teamio support.</span></div>

			<!-- <div class="version-container">
				v1.0.0
			</div> -->
		</div>
	</div>
</template>

<script>
import ConversationsContainerV2 from './ConversationContainerV2.vue';
import { mapActions } from 'vuex';
import mixin from '../../mixin.js';

export default {
		components: {
		ConversationsContainerV2
	},
	mixins: [mixin],

	created() {
		// Component initialization
	},
	
	mounted() {
		// Component mounted
	},

	data() {
		return {
			theme: 'light',
			showChat: true,
			users: [
				{
					employeeID: 'c7ee40b0-d86d-11e9-bac0-0ad6daef1536',
					username: 'Nilay Shah',
					avatar: 'https://vignette.wikia.nocookie.net/teamavatarone/images/4/45/Yoda.jpg/revision/latest?cb=20130224160049',
				},
				{
					employeeID: 'c7e82221-d86d-11e9-bac0-0ad6daef1536',
					username: 'Sam Smith',
					avatar: 'https://avatarfiles.alphacoders.com/184/thumb-184913.jpg',
				},
				{
					employeeID: 'c7e0b46b-d86d-11e9-bac0-0ad6daef1536',
					username: 'Nicole Jones',
					avatar: 'https://avatarfiles.alphacoders.com/184/thumb-184913.jpg',
				}

			],
			updatingData: false
		}
	},

	watch: {
		userID() {
			this.showChat = false;
			setTimeout(() => {
				this.showChat = true;
			}, 150);
		}
	},

	methods: {
        ...mapActions('chat', ['addChatData']),
		async addData() {
            this.updatingData = true;
            let payload = {
                users: this.users,
                lastUpdated: new Date()
            }
            await this.addChatData(payload);
			this.updatingData = false;
		}
	},

	computed: {
		shouldEnableConversations() {
			return !!this.allSettings;
		},
		userID() {
			return this.user ? this.user.EmployeeID : null;
		}
	}
}
</script>

<style lang="scss">
body {
	background: #fafafa;
}

.app-container {
	font-family: 'Quicksand', sans-serif;
	padding: 10px 20px 20px;

	@media only screen and (max-width: 768px) {
		padding: 0;
	}
}

select {
	height: 20px;
	outline: none;
	border: 1px solid #e0e2e4;
	background: #fff;
}

.user-logged {
	font-size: 12px;
	margin-right: 5px;
}

.button-theme {
	float: right;

	.button-light {
		background: #fff;
		border: 1px solid #46484e;
		color: #46484e;
	}

	.button-dark {
		background: #1c1d21;
		border: 1px solid #1c1d21;
	}

	button {
		color: #fff;
		outline: none;
		cursor: pointer;
		border-radius: 4px;
		padding: 6px 12px;
		margin-left: 10px;
		border: none;
		font-size: 14px;
		transition: 0.3s;
		vertical-align: middle;

		&:hover {
			opacity: 0.8;
		}

		&:active {
			opacity: 0.6;
		}

		@media only screen and (max-width: 768px) {
			padding: 3px 6px;
			font-size: 13px;
		}
	}
}

.version-container {
	padding-top: 20px;
	text-align: right;
	font-size: 14px;
	color: grey;
}
</style> 